// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"ba8c2b44","977":"bc111528"}[chunkId] + ".chunk.js";
};